import React, { createContext, useState, useContext } from 'react';

const OnSelectMenuContext = createContext();

export default function OnSelectMenuProvider({ children }) {
    const [onSelectMenu, setOnSelectMenu] = useState(null);
    const [isLateralMenuActive, setIsLateralMenuActive] = useState(false);

    return (
        <OnSelectMenuContext.Provider value={{ onSelectMenu, setOnSelectMenu, isLateralMenuActive, setIsLateralMenuActive }}>
            {children}
        </OnSelectMenuContext.Provider>
    );
}

export function useOnSelectMenu() {
    const context = useContext(OnSelectMenuContext);

    if (!context) throw new Error('useOnSelectMenu must be used within a OnSelectMenuProvider');

    return context;
}